import React, {Component} from 'react';
import ProSignUpPart1Form from "./ProSignUpPart1Form";
import ProSignUpPart2Form from "./ProSignUpPart2Form";
import {AIRTABLE_HOOKS_ROOT} from "../config";

const shareMessage = "Hey! I just signed up for SingleShift (https://singleshift.sg/pros). You should sign up too. SingleShift let's you earn money picking up shifts at restaurants and events from your phone. If you enter my phone number when you sign up, we will both get a 10% wage increase bonus on our next shift.";

class ProSignUpForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      part: 1,
      name: null,
      email: null,
      phone: null,
      id: null,
    }
  }

  part1Submit = (values) => {
    window.analytics.track("Pros Sign Up - Part 1 Completed", {
      "name": values.name,
      "email": values.email,
      "phone": values.phoneNumber,
    });
    this.setState({
      name: values.name,
      email: values.email,
      phone: values.phoneNumber,
    });

    return fetch(`${AIRTABLE_HOOKS_ROOT}/pros/`, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json()).then(body => {
      this.setState({
        part: 2,
        id: body.id,
      });
      window.scrollTo(0, 0);
    });
  };

  part2Submit = (values) => {

    window.analytics.track("Pros Sign Up - Completed", {
      "name": this.state.name,
      "email": this.state.email,
      "phone": this.state.phone,
    });

    values['id'] = this.state.id;
    return fetch(`${AIRTABLE_HOOKS_ROOT}/experience/`, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json()).then(body => {
      this.setState({
        part: 3,
      })
    });
  };

  shareWhatsApp = () => {
    window.analytics.track("Pros Sign Up - Share", {"Network": "WhatsApp"});
  };

  shareFacebook = () => {
    window.analytics.track("Pros Sign Up - Share", {"Network": "Facebook"});
  };

  render() {
    return (
      <div className="sign-up-form">
        {(this.state.part === 1) ? (
          <ProSignUpPart1Form hidden={!(this.state.part === 1)} onSubmit={this.part1Submit}/>
        ) : null}
        {(this.state.part === 2) ? (
          <ProSignUpPart2Form hidden={!(this.state.part === 2)} onSubmit={this.part2Submit}/>
        ) : null}
        {(this.state.part === 3) ? (
          <div id="part3-confirmation">
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-6">
                <div className="alert alert-success" role="alert">
                  <b>Thanks for signing up!</b> You will receive a text message after we review your information.
                </div>
              </div>
            </div>
            <div className="row justify-content-center header">
              <div className="col-md-12 col-lg-6">
                <h4>Earn More, Invite Your Friends</h4>
                <p className="text-muted">
                  Get a 10% wage increase bonus on the next shift for you and each friend you invite to try
                  SingleShift.
                </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-6">
                <a id="shareWhatsApp" target="_blank" href={`whatsapp://send?text=${shareMessage}`}
                   onClick={this.shareWhatsApp}
                   data-action="share/whatsapp/share"
                   className="share-btn btn btn-outline-primary btn-block">Send on WhatsApp →</a>
                <a id="shareFacebook"
                   target="_blank"
                   onClick={this.shareFacebook}
                   href={`https://www.facebook.com/sharer/sharer.php?u=https://singleshift.sg/pros&quote=${encodeURIComponent(shareMessage.trim())}`}
                   className="share-btn btn btn-outline-primary btn-block">Share on Facebook →</a>
              </div>
            </div>
          </div>
          ) : null}
      </div>
    );
  }
}


export default ProSignUpForms;


// WEBPACK FOOTER //
// ./src/parts/ProSignUpForms.js